<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center mb-5"><img src="img/logo.png" style="width: 80%;"></div>
          <!--div class="text-muted text-center mt-2 mb-3">
              Sign in
          </div-->
          <base-alert type="danger" class="mt-3" v-if="message !== ''">
           {{message}} 
          </base-alert>
          <base-alert type="success" class="mt-3" v-if="success">
            Your new password has been sent ! look in your mailbox.
          </base-alert>
          <form name="forgot" role="form" @submit.prevent="handle(!v$.$invalid)" novalidate>
            <base-input
              formClasses="input-group-alternative mb-3"
              placeholder="Email"
              addon-left-icon="ni ni-email-83"
              v-model="v$.user.email.$model"
              :valid="isValid(v$.user.email)"
              focused
              required
            >
            </base-input>
            <div class="text-center">
              <base-button nativeType="submit" type="primary" class="my-4" :disabled="loading">Send password</base-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <router-link to="/login" class="text-light">
            <small>Sign in</small>
          </router-link>
        </div>
        <div class="col-6 text-right">
          <router-link to="/register" class="text-light"
            ><small>Create account</small></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import axios from 'axios';

export default {
  name: "forgot",
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      user: {
        email: ""
      },
      loading: false,
      isSubmitted: false,
      success: false,
      message: ""
    };
  },
  validations() {
    return {
        user: {
            email: {required, email}
        } 
    } 
  },
  computed: {
      isAuthenticated() {
          return this.$store.getters.isAuthenticated;
      }
  },
  created() {
      if (this.isAuthenticated) {
          this.$router.push('/');
      }
  },
  methods: {
      isValid(item){
        if (!this.isSubmitted){
          return null;
        } 

        return !item.$invalid;
      }, 
      handle(isValid) {
          this.isSubmitted = true;
          this.message = '';
          
          if (!isValid){
              return;
          } 

          this.loading = true;
          axios.post(`/forgot-password`, this.user)
          .then(() =>{
                this.success = true
          } , error => {
                this.loading = false;
                this.message = (error.response && error.response.data && error.response.data.message);
          })
      } 
  }
};
</script>
<style>
/*html, body, #app, .auth-layout {
  height: 100%;
} */   
</style>
